import FindingCard, { VendorIdentity, OtherAnalytics } from './finding-card'

// Eyebrow wording comes from Monitoring::FlagEvidence. The card opens the first test
// that fired; each other test gets its own button.
const EvidenceFindingCard = ({ transaction, onOpenReview }) => {
  const evidence = transaction.evidence
  const analytics = transaction.analytics || []
  const sectionFields = transaction.section_fields
  const tests = evidence.tests?.length ? evidence.tests : [evidence]

  const analyticFor = (test) =>
    analytics.find((entry) => entry.id === test.analytic_id) || {
      id: test.analytic_id,
      name: test.analytic_name
    }
  const testIds = tests.map((test) => test.analytic_id)
  const hasOthers = analytics.some((entry) => !testIds.includes(entry.id))
  const eyebrow = tests.map((test) => test.headline).filter(Boolean).join(' · ') || 'Finding'

  return (
    <FindingCard
      transaction={transaction}
      eyebrow={eyebrow}
      onOpen={() => onOpenReview(transaction, analyticFor(tests[0]), 'evidence')}
    >
      <div className="monitoring-match">
        <div style={{ minWidth: 0 }}>
          <div className="text-muted small">Vendor</div>
          <VendorIdentity
            name={transaction.vendor_name}
            externalId={transaction.external_id}
            status={sectionFields?.vendor_status}
          />
        </div>
      </div>

      {tests.length > 1 && (
        <div className="d-flex align-items-center flex-wrap gap-2 mt-3">
          {tests.slice(1).map((test) => (
            <button
              key={test.analytic_id}
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={(event) => {
                event.stopPropagation()
                onOpenReview(transaction, analyticFor(test), 'evidence')
              }}
              // The card opens on Enter/Space too; stop it opening over this test.
              onKeyDown={(event) => event.stopPropagation()}
            >
              Open {test.headline.toLowerCase()} evidence
            </button>
          ))}
        </div>
      )}

      {hasOthers && (
        <div className="d-flex align-items-center flex-wrap gap-2 mt-3">
          <OtherAnalytics analytics={analytics} exceptIds={testIds} />
        </div>
      )}
    </FindingCard>
  )
}

export default EvidenceFindingCard
